export default "__VITE_ASSET__DeHZiRYB__"